// TODO: replace with a real Adressevaelger token - see https://confluence.sdfi.dk/display/ADV/Brugerstyring
export const ADRESSEVAELGER_TOKEN = "f7e558929f693c476e4aeda57cf2b4df";
